import { initCommerceApiWithGlobals } from 'common-api';
import { isBrowser, logger } from 'common-ui';
import { useUserStore } from '../../stores/userStore';
import { useInitCartState } from './useInitCartState';
import type { UserDetails } from 'tsconfig/types.d';

const useInitUserState = (): (() => Promise<UserDetails | null>) => {
  const currentUserData = useUserStore.getState().user;

  return async (): Promise<UserDetails | null> => {
    if (isBrowser()) {
      if (currentUserData) {
        useUserStore.getState().setUser({ ...currentUserData, userLoded: true });
        logger.log('skipping init fetch of user data as already defined');
        return currentUserData;
      }

      try {
        const commerceApi = initCommerceApiWithGlobals();
        const newUserData = await commerceApi.User.get();
        useUserStore.getState().setUser({ ...newUserData?.response, userLoded: true });
        return newUserData?.response;
      } catch (e) {
        logger.log('API ERROR', e);
        return null;
      }
    } else {
      logger.log('useInitUserState skipping fetch as not in browser');
      return null;
    }
  };
};

export const useInitCoreAppState = () => {
  const initCartState = useInitCartState();
  const initUserState = useInitUserState();

  return async () => {
    await initUserState();
    initCartState();
  };
};
